export const ITEM_TABLE_HEADER = [
  {
    displayName: 'Vonalkód',
    ref: 'barcode',
  },
  {
    displayName: 'Raktári jelzet',
    ref: 'warehouseIdentifierUniqueString',
  },
  {
    displayName: 'Lelőhely',
    ref: 'intendedLocation.displayName',
    // metadataKey: 'PRESEED:Item:locationCategory',
  },
  {
    displayName: 'Virtuális kollekció',
    ref: 'virtualCollection.displayName',
  },
  {
    displayName: 'Kategória',
    ref: 'semanticCategory.displayName',
  },
  {
    key: 'semanticStatus',
    displayName: 'Státusz',
    ref: 'semanticStatus.displayName',
  },
  {
    displayName: 'Műveletek',
    ref: 'operations',
  },
];

export const ITEM_TABLE_HEADER_IN_MOBILE = [
  {
    displayName: 'Raktári jelzet',
    ref: 'warehouseIdentifierUniqueString',
  },
  {
    key: 'semanticStatus',
    displayName: 'Státusz',
    ref: 'semanticStatus.displayName',
  },
  {
    displayName: 'Műveletek',
    ref: 'operations',
  },
];
